import { BaseOwnerEntity } from "../../entity/baseOwnerEntity";

export class OrderItemEntity extends BaseOwnerEntity {
  id?: number;
  orderId?: number;
  productId?: number;
  orderItemStatusId?: number;
  unitId?: number;
  quantity?: number;
  numberOfUnits?: number;
  deliveryDate?: Date;
  preparedDate?: Date;
  deliveredDate?: Date;
  preparedUser?: number;
  deliveringUser?: number;
  description?: string;
  deliveredNotes?: string;
  packId?: number;
  isRequiredApprove?: boolean;
  width?: number;
  length?: number;
  hangerTypeId?: number;
  hangerPrice?: number;
  assignedUserId?: number;
  labelTag?: string;
  isExpress?: boolean;
}